import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { productConfig } from '@shared/config';
import enCommon from './en/common.json';
import enLanding from './en/landing.json';
import enAuth from './en/auth.json';
import enMarketing from './en/marketing.json';
import enLegal from './en/legal.json';
import arCommon from './ar/common.json';
import arLanding from './ar/landing.json';
import arAuth from './ar/auth.json';
import arMarketing from './ar/marketing.json';
import arLegal from './ar/legal.json';

const STORAGE_KEY = 'careerlaunch-language';

function getInitialLanguage(): 'en' | 'ar' {
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'en' || saved === 'ar') return saved;
  return window.navigator.language.toLowerCase().startsWith('ar')
    ? 'ar'
    : productConfig.defaultLanguage;
}

function applyDocumentLanguage(language: string): void {
  const resolved = language.startsWith('ar') ? 'ar' : 'en';
  document.documentElement.lang = resolved;
  document.documentElement.dir = resolved === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.dataset.language = resolved;
  window.localStorage.setItem(STORAGE_KEY, resolved);
}

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      landing: enLanding,
      auth: enAuth,
      marketing: enMarketing,
      legal: enLegal,
    },
    ar: {
      common: arCommon,
      landing: arLanding,
      auth: arAuth,
      marketing: arMarketing,
      legal: arLegal,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  supportedLngs: [...productConfig.supportedLanguages],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
    defaultVariables: { brandName: productConfig.brandName },
  },
  returnObjects: true,
});

applyDocumentLanguage(i18n.resolvedLanguage ?? i18n.language);
i18n.on('languageChanged', applyDocumentLanguage);

export default i18n;
